<template>
    <div class="sub-navbar">
        <div class="container-item" v-for="item in struct" v-can="item.permission">
            <div class="btn-tmp" :class="item.active ? 'active' : ''">
                <router-link  :to="{name:item.path}" class="item">{{ item.name }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    //import Component from 'path/to/component'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {},
        computed: {},
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {},
        mounted: function () {

        },
        name: '',
        props: ['struct'],
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">

    .btn-tmp{


        &.active{
            //border-bottom: 4px solid $main-color;

        }
    }

    .sub-navbar {
        background-color: #FFFFFF;
        width: 100%;
        height: 50px;
        display: flex;
        /*position:fixed;
        top:70px;*/
        z-index:1000;



        a {
            text-decoration: none;
            color:$main-white;
        }

        .container-item{
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 1;
        }

        .item {
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 1;
            height:100%;
        }

        .btn-tmp{
            width:100%;
            height:100%;
            background-color: $secondary-color;
            border-top: 4px solid $main-color;

            &.active{
                border-top: 4px solid transparent;
                background-color: hsla(hue($main-color),10,lightness($main-color),0.1);

                a{
                    color: $secondary-color;
                    font-weight: $bold;
                }
            }

            &:hover:not(.active){
                background-color: darken($main-color,20%);
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/ui/SubNavBar.vue